import polyglotI18nProvider from 'ra-i18n-polyglot';
import {
  resolveBrowserLocale,
  TranslationMessages,
  mergeTranslations,
} from 'react-admin';
import customEnglishMessages from './en';
import customFrenchMessages from './fr';
import {
  raSearchLanguageEnglish,
  raSearchLanguageFrench,
} from '@react-admin/ra-search';
import {
  raAuditLogLanguageEnglish,
  raAuditLogLanguageFrench,
} from "@react-admin/ra-audit-log";

const messages: { [key: string]: TranslationMessages } = {
  en: mergeTranslations(customEnglishMessages, raSearchLanguageEnglish),
  'fr-CA': mergeTranslations(customFrenchMessages, raSearchLanguageFrench),
};

export const i18nProvider = polyglotI18nProvider(
  (locale: string) => (messages[locale] ? messages[locale] : messages.en),
  resolveBrowserLocale('en', { fullLocale: true })
);
